interface CopyrightProps {
  className?: string;
}

export function Copyright({ className }: CopyrightProps) {
  return (
    <div className={className}>© {new Date().getFullYear()} TurtleWave</div>
  );
}
